<script lang="ts">
import { LOG_CODE } from '@/app/const';
import { ComplaintActivityLog } from '@/interface/Complaint.interface';
import { complaintService } from '@/services/serviceProvider';
import { groupBy } from '@/app/common/types/groupBy.type';
import HistoryInfo from '../shared/historyInfo.vue';
import { useI18n } from 'vue-i18n';
import CommonService from '@/services/commonService';

export default {
    components: {
        HistoryInfo
    },
    setup() {
        const { t } = useI18n();
        const commonSv = new CommonService(t);

        return { commonSv }
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        header: {
            type: String,
            default: 't-action-history'
        },
        items: {
            type: Array<Object>,
            default: []
        }
    },
    emits: ['update:modelValue', 'onConfirm'],
    data() {
        return {
            histories: this.items as ComplaintActivityLog[],
            panel: [] as string[],
        }
    },
    watch: {
        items: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.histories = newVal as ComplaintActivityLog[]
                }
            }, deep: true
        },
    },
    computed: {
        dialogShow: {
            get() {
                return this.modelValue || false
            },
            set(newValue: boolean) {
                this.$emit('update:modelValue', newValue);
            }
        },
        topHistories(): ComplaintActivityLog[] {
            let hGroups = this.historiesForGroup;
            let results = this.histories.filter(o => ((!o.departmentCode || o.departmentCode === "") && (!o.groupDepartmentCode || o.groupDepartmentCode === ""))
                || (o.departmentCode === "ASC" && (!o.groupDepartmentCode || o.groupDepartmentCode === "")));
            if (hGroups && hGroups.length > 0 && hGroups[hGroups.length - 1].createDate) {
                let lastCreateDateOfGroup = hGroups[hGroups.length - 1].createDate;
                if (lastCreateDateOfGroup)
                    return results.filter(o => o.createDate && o.createDate < lastCreateDateOfGroup)
            }
            return results;
        },
        historiesForGroup() {
            return this.histories.filter(o => (o.departmentCode && o.departmentCode !== "" && o.groupDepartmentCode)
                || ((!o.departmentCode || o.departmentCode === "") && o.groupDepartmentCode))
        },
        historiesByDpm() {
            const grouped = groupBy(this.historiesForGroup, ['groupDepartmentCode'])
            let results = [] as any[];
            Object.entries(grouped).forEach(([departmentCode, docs]) => {
                let rs = {} as any;
                rs.departmentCode = departmentCode;
                rs.histories = docs;
                results.push(rs);
            });
            return results;
        },
        bottomHistories(): ComplaintActivityLog[] {
            let hGroups = this.historiesForGroup;
            let results = this.histories.filter(o => ((!o.departmentCode || o.departmentCode === "") && (!o.groupDepartmentCode || o.groupDepartmentCode === ""))
                || (o.departmentCode === "ASC" && (!o.groupDepartmentCode || o.groupDepartmentCode === "")));
            if (hGroups && hGroups.length > 0 && hGroups[hGroups.length - 1].createDate) {
                let lastCreateDateOfGroup = hGroups[hGroups.length - 1].createDate;
                if (lastCreateDateOfGroup)
                    return results.filter(o => o.createDate && o.createDate > lastCreateDateOfGroup)
            }
            else if (this.topHistories.length > 0 && hGroups && hGroups.length === 0) {
                let lastCreateDateTop = this.topHistories[this.topHistories.length - 1].createDate;
                if (lastCreateDateTop)
                    return results.filter(o => o.createDate && o.createDate > lastCreateDateTop)
            }
            return results;
        },
    },
    mounted() {
        // this.panel = this.historiesByDpm.map(o => o.departmentCode)
    },
    methods: {
        confirm() {
            this.dialogShow = false;
            this.$emit('onConfirm')
        },
    }
}
</script>

<template>
    <v-dialog v-model="dialogShow" width="70%" :close-on-back="false" persistent>
        <v-container>
            <v-card class="dialog-card pb-6">
                <v-toolbar density="compact">
                    <v-toolbar-title>{{ $t(header) }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items class="d-flex align-center close-modal">
                        <v-btn class="h-fit-content pa-2" icon="mdi-close" @click="dialogShow = false"></v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text style="max-height: 80vh; overflow-y: auto; position: relative; overflow-x: hidden;">
                    <HistoryInfo v-model="topHistories"></HistoryInfo>
                    <v-expansion-panels v-if="panel" v-model="panel" class="app-card ma-0 pa-0" multiple>
                        <v-expansion-panel v-for="hgroup in historiesByDpm" :value="hgroup.departmentCode" class="mb-6">
                            <v-expansion-panel-title class="pt-3" static>
                                <div class="d-flex align-center">
                                    <v-toolbar-title>
                                        <!-- <div class="text-label-large mb-0">{{ hgroup.departmentCode }}</div> -->
                                        <v-chip color="primary" size="large">{{ hgroup.departmentCode }}</v-chip>
                                    </v-toolbar-title>
                                    <div class="mx-6 d-flex align-center">
                                        <span class="mr-2">{{ $t('t-action-history-duration-dpm') }}</span>
                                        <span v-if="hgroup.histories.length > 1">
                                            {{ commonSv.durations(hgroup.histories[0].createDate,
                                                hgroup.histories[hgroup.histories.length - 1].createDate) }}
                                        </span>
                                        <span v-else-if="hgroup.histories.length == 1 && (hgroup.histories[hgroup.histories.length - 1].detail == '\{end-request-no\}'
                                            || hgroup.histories[hgroup.histories.length - 1].detail == '\{appeal-request-no\}')
                                            && topHistories[0].createDate">
                                            {{ commonSv.durations(topHistories[0].createDate,
                                                hgroup.histories[hgroup.histories.length - 1].createDate) }}
                                        </span>
                                        <span v-else>
                                            {{ commonSv.durations(hgroup.histories[hgroup.histories.length -
                                                1].createDate,
                                                new Date()) }}
                                        </span>
                                    </div>
                                </div>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text class="px-1 py-3">
                                <HistoryInfo v-model="hgroup.histories" :group-dpm-code="hgroup.departmentCode">
                                </HistoryInfo>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <HistoryInfo v-model="bottomHistories" :start-date="topHistories[0]?.createDate"
                        :end-date="bottomHistories[bottomHistories.length - 1]?.createDate"></HistoryInfo>
                </v-card-text>
            </v-card>
        </v-container>
    </v-dialog>
</template>